@if (activeStatus?.severity && !onlyIcon()) {
  <p-tag
    [severity]="activeStatus!.severity"
    [value]="activeStatus!.label ?? activeStatus!.labelCs ?? activeStatus!.labelEn" />
} @else if (activeStatus) {
  <span class="status-wrapper flex items-center" [pTooltip]="tooltip">
    @if (activeStatus.iconName) {
      <i
        [style.color]="activeStatus.iconColor"
        [class]="'pi pi-' + activeStatus.iconName + (onlyIcon() ? '' : ' mr-1.5')">
      </i>
    }
    @if (!onlyIcon()) {
      @if (activeStatus.label) {
        <span [style.color]="activeStatus.labelColor">
          {{ activeStatus.label + (label() ? ':' : '') }}
        </span>
      }
      @if (activeStatus.labelCs) {
        <span [style.color]="activeStatus.labelColor">
          {{ activeStatus.labelCs + (label() ? ':' : '') }}
        </span>
      }
      @if (activeStatus.labelEn) {
        <span [style.color]="activeStatus.labelColor">
          {{ activeStatus.labelEn + (label() ? ':' : '') }}
        </span>
      }
    }
  </span>
}
